// Finar rev-B 11 — "Gösterge şu veri setlerinde kullanılıyor; önce oradan çıkarın: <Müşteri · Veri
// seti>, …" — her set Veri Yönetimi'ne (o müşteri + veri seti seçili) bağlantı. Sunucu set listesi
// vermediyse yalnız mesaj. MetricModal hata kutusu ve katalog hızlı kaldırma bandı ortak kullanır.

import { Link } from "react-router-dom";
import { kpiSetManagementHref, KPI_COPY } from "../../lib/kpi-ui";
import type { FormulaServerError } from "./FormulaEditor";

export function MetricErrorText({ error }: { error: FormulaServerError }): JSX.Element {
  const sets = error.inUseSets ?? [];
  if (sets.length === 0) return <>{error.message}</>;
  return (
    <span data-testid="kpi-metric-in-use">
      {KPI_COPY.metricInUse.lead}{" "}
      {sets.map((s, i) => (
        <span key={s.id}>
          {i > 0 ? ", " : null}
          <Link
            to={kpiSetManagementHref(s.clientId, s.id)}
            style={{ color: "inherit", textDecoration: "underline", fontWeight: 600 }}
          >
            {KPI_COPY.metricInUse.setLabel(s.clientName, s.name)}
          </Link>
        </span>
      ))}
    </span>
  );
}
